<template>
  <div>
    <h1>Kötelező tervezői és mérnöki szakmai felelősségbiztosítás</h1>
    <div class="mb-2" style="text-align: justify;">
      Biztosított: A Szerződő és a Szerződővel munkaviszonyban, munkavégzésre irányuló egyéb
      jogviszonyban álló személyek, alkalmazottak, valamint a Szerződő szolgáltatás teljesítése
      érdekében jogosan igénybevett közreműködő személyek – így különösen a Szerződő által bevont
      alvállalkozók. A közreműködő személyekre, alvállalkozókra kizárólag a jelen szerződésben /
      Biztosítási részletezőn feltüntetett tevékenységek végzésével kapcsolatban vonatkozik a
      fedezet.
    </div>
    <div class="mb-2" style="text-align: justify;">
      Fedezet típusa: <b>Tervezők, Mérnökök Szakmai Felelősségbiztosítása</b>, mely az alábbi
      fedezeti elemeket tartalmazza:
    </div>
    <div class="mb-2">
      <ul>
        <li>
          <b>Szakmai felelősség személyi sérüléses és dologi károk fedezet </b><br />
          A Biztosító megtéríti a Biztosított helyett a Biztosított által elkövetett
          Kötelezettségszegés kapcsán érvényesített Kárigényből származó Kárt, jelen esetben
          személyi sérüléses és dologi károkat, valamint e károkkal összefüggésben bekövetkezett
          személyi sérüléses nem vagyoni sérelmekre tekintettel felmerülő sérelem díjakra, mely
          károk megtérítéséért a Biztosított jogszabály szerint karteritesi felelősséggel tartozik,
          a sérelemdíjak tekinteteben fizetési kötelezettséggel tartozik.
        </li>
        <li><b>Jogi védelmi költségek fedezet</b><br /></li>
        <li><b>Bíróságon való megjelenés költségtérítése</b><br /></li>
        <li v-show="financial_losses">
          <b>Szakmai felelősség tisztán pénzügyi veszteségek fedezet</b><br />
          A Biztosító megtéríti a Biztosított helyett a Biztosított által elkövetett
          Kötelezettségszegés kapcsán érvényesített Kárigényből származó Kárt, jelen esetben tisztán
          pénzügyi veszteségeket.
          <ul>
            <li>
              <b>Személyhez fűződő jogok megsértése fedezet</b><br />A Biztosító megtéríti a
              Biztosított helyett a Biztosítottal szemben a személyhez fűződő jogok megsértése miatt
              érvényesített Kárigényekből származó Kárt.
            </li>
            <li>
              <b>Szellemi alkotáshoz fűződő jogok megsértése fedezet</b><br />A Biztosító megtéríti
              a Biztosított helyett a Biztosítottal szemben a Szellemi alkotáshoz fűződő jogok
              megsértése kapcsán érvényesített kárigényből származó kárt.
            </li>
            <li>
              <b>Internettel kapcsolatos felelősség fedezet</b><br />A Biztosító megtéríti a
              Biztosított helyett a Biztosítottal szemben az internet használattal kapcsolatosan
              érvényesített Kárigényből származó Kárt.
            </li>
          </ul>
        </li>
        <li v-if="merchant_id === 'eurosales'">
          <b>Dokumentumok, elektronikus nyilvántartások pótlása fedezet</b>
        </li>
        <li v-if="merchant_id === 'eurosales'">
          <b>Kárenyhítési költség fedezet</b>&nbsp;<span
            class="info"
            id="karenyhitesi_koltseg-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
            >?</span
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import {mapActions} from 'vuex';

export default {
  components: {},
  computed: {
    ...mapFields([
      'currency',
      'insuranceYearlyPrice',
      'eves_dij',
      'merchant_id',
      'financial_losses',
    ]),
  },
  mounted() {
    this.$store.dispatch('updateMarks');
  },
};
</script>
<style lang="scss">
$red: #e4002b;
.sub {
  color: $red;
  margin-bottom: 10px;
}
</style>
